import { Directive, ElementRef, Input } from '@angular/core';
import { ExpirationType } from 'src/app/core/api/models';

@Directive({
  selector: '[expirationType]',
  standalone: true,
})
export class ExpirationTypeDirective {
  @Input('expirationType') expirationType: ExpirationType;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi tw-font-bold mdi-20px ';

    switch (this.expirationType) {
      case ExpirationType.Hour:
        classList += 'mdi-clock-outline text-rose';
        break;
      case ExpirationType.Daily:
        classList += 'mdi-calendar-today text-info';
        break;
      case ExpirationType.Weekly:
        classList += 'mdi-calendar-week text-primary';
        break;
      case ExpirationType.Monthly:
        classList += 'mdi-calendar-month text-blue';
        break;

      default:
        break;
    }
    return classList;
  }
}
